import axios from "./axios"

/**
 * 個案查詢
 * @param {*} serviceType 
 * @param {*} spNo 
 */
const getBySpNo = (serviceType,spNo) => {
    return axios.get(`/public/api/v1/school/${serviceType}?spNo=${spNo}`).then(res=>res.data)
}

/**
 * 發起支付
 * @param {*} serviceType 
 * @param {*} applicationNo 
 * @param {*} channel 
 * @param {*} email 
 */
const pay = (serviceType, applicationNo, channel, token, email) => {
    return axios.get(`/public/api/v1/school/start/pay/${serviceType}?applicationNo=${applicationNo}&channel=${channel}${token ? `&token=${token}`:''}${email ? `&email=${email}`:''}`).then(res => res)
}

/**
 * 校驗支付頻率
 * @param {*} applicationNo 
 */
const frequency = applicationNo =>{
    return axios.get(`/public/api/v1/school/frequency?applicationNo=${applicationNo}`).then(res=>res.data)
}

export default {
    getBySpNo,
    pay,
    frequency
}